import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=00fc40f1&scoped=true&"
import script from "./publish.vue?vue&type=script&lang=js&"
export * from "./publish.vue?vue&type=script&lang=js&"
import style0 from "./publish.vue?vue&type=style&index=0&id=00fc40f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fc40f1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Tip2: require('/builds/master/frontend/frontend-universe/components/tip2.vue').default})
